<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <div *ngIf="!isLocationOnBusinessPlan">
    <ngb-alert [dismissible]="false" class="text-center w-100 mt-3">
      The features on this page are not available on the {{ plansAlertData.notAvailableForPlan }}.
      <a routerLink="/settings/location/billing" class="alert-link" [innerText]="plansAlertData.linkText"></a>
      {{ plansAlertData.afterLinkText }}
    </ngb-alert>
  </div>

  <h1 class="pt-3 mb-2">Integrations</h1>

  <tablesready-public-api [disabled]="!isLocationOnBusinessPlan"></tablesready-public-api>

  <tablesready-square-settings [disabled]="!isLocationOnBusinessPlan"></tablesready-square-settings>

  <tablesready-webhooks [disabled]="!isLocationOnBusinessPlan"></tablesready-webhooks>

  <tablesready-reserve-with-google
    [locationOnBusinessPlan]="isLocationOnBusinessPlan"
    *ngIf="account.features.reserveWithGoogle"
  ></tablesready-reserve-with-google>

  <tablesready-stripe-integration
    *ngIf="account.features.paymentAccepting"
    [disabled]="!isLocationOnBusinessPlan"
  ></tablesready-stripe-integration>

</section>
